import { Store } from '../hooks/types'

const formatName = (name: string) => {
  const lowerCaseName = name.toLowerCase()
  if (lowerCaseName.includes('manchester')) return 'cinch OMODA & JAECOO'
  if (lowerCaseName.includes('land rover')) return 'Marshall Land Rover'
  if (lowerCaseName.includes('omoda')) return 'Marshall OMODA & JAECOO'
  if (lowerCaseName.includes('audi')) return 'Audi'
  if (lowerCaseName.includes('cinch birmingham')) return 'cinch'

  return name.split(' ').slice(0, 2).join(' ')
}

export const formatAddress = (store: Store) => {
  const county = store.town !== store.county && store.county ? store.county : ''

  return [
    formatName(store.name),
    store.addressLine1,
    store.town,
    county,
    store.postcode,
  ]
    .filter(Boolean)
    .join(', ')
}
